module.exports = __webpack_public_path__ + "static/media/gender.ce04ccff.svg";